import React, {useEffect, useState} from 'react';
import Link from "next/link";
import styled from "styled-components";
import ModalLayout from "@layouts/modal";
import {getDistricts} from "@models/district";
import {getCityURL} from "@models/district";
import {getUrlDealTypes, getUrlTypes} from "@models/property";
import CircleLoading from "@molecules/lotties/circle_loading";
import {str_replace} from "@helpers/helpers";
import {scrollToOffsetTop} from "@helpers/helpers";
import {isEmpty} from "@helpers/helpers";
import Icon from "@atoms/icon";
import PinIcon from '@icons/pin.svg';
import ChevronLeftIcon from '@icons/chevron-left.svg';

const LandingOtherAreasModal = ({city_id, show, setShow}) => {
    const [search, setSearch] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [cityUrl, setCityUrl] = useState('');

    const handleSearch = async (e) => {
        let pattern = String(e.target.value).toLowerCase();
        const updatedList = districts.filter(item => {
            return (
                item.name.toLowerCase().search(pattern) !== -1
            );
        });

        for (let district of updatedList) {
            district.url = handleItemUrl(cityUrl, district.name);
        }

        setSearch(updatedList)
    };

    useEffect(() => {
        setSearch([]);
    }, [show]);

    useEffect( () => {
        (async () => {
            if (!isEmpty(city_id)) {
                const city_url = await getCityURL(city_id);
                setCityUrl(city_url);

                getDistricts(city_id).then((result) => {
                    let {districts} = result;

                    for (let district of districts) {
                        district.url = handleItemUrl(city_url, district.name);
                    }

                    setDistricts(districts)
                })
            }
        })()
    }, []);

    const handleItemUrl = (city_url, district_name) => {
        const district_url = str_replace(' ', '-', district_name);
        const propertyDealTypeUrl = getUrlDealTypes('sale');
        const propertyTypeUrl = getUrlTypes('villa.house');

        return '/' + city_url + '/' + propertyDealTypeUrl + '-' + propertyTypeUrl + '/' + district_url;
    };

    return (
        <ModalLayout show={show} setShow={setShow} modalDialogClass="modal-sm" dialogBodyClassName="px-0">
            <Header className="d-flex align-items-center justify-content-center pb-16">
                <h2>انتخاب محله</h2>
            </Header>

            {
                (districts.length) ?
                    <React.Fragment>
                        <div className="form-group px-24">
                            <input type="text" onChange={handleSearch} className="form-control" placeholder="جستجو..."/>
                        </div>

                        <Body className="">
                            <ul>
                                {
                                    (search && search.length) ?
                                        search.map((district, key) =>
                                            <Item key={district.id} label={district.name} url={district.url}/>
                                        )
                                        :
                                        (districts.length) ?
                                            districts.map((district, key) =>
                                                <Item key={district.id} label={district.name} url={district.url}/>
                                            )
                                            : ''
                                }
                            </ul>
                        </Body>
                    </React.Fragment>
                    :
                    <div className="text-center py-48">
                        <CircleLoading width={64} height={64}/>
                    </div>
            }
        </ModalLayout>
    )
};

export default React.memo(LandingOtherAreasModal)

const Item = ({key, label, url}) => {

    const handleListClick = () => {
        scrollToOffsetTop(0, 0, false);
    };

    return (
        <li key={key} className="px-24" onClick={() => handleListClick()}>
            <Link href="/properties" as={url}>
                <a className="d-flex align-items-center justify-content-between py-8">
						<span className="d-flex align-items-center">
							<Icon width={16} height={16}><PinIcon/></Icon>
							<span className="mr-16">{label}</span>
						</span>

                    <Icon className="chevron-left"><ChevronLeftIcon/></Icon>
                </a>
            </Link>
        </li>
    )
};

// styles

const Header = styled.div`
    line-height: 0;
`;

const Body = styled.div`
    height: calc(100vh - 430px) !important;
    overflow: auto;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        height: calc(100vh - 320px) !important;
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        height: calc(100vh - 250px) !important;
    }
    
    .icons {
        &.chevron-left {
            width: 6px;
        }
    }
    
    li {
        &:hover {
            background-color: ${props => props.theme.gray200};
        }
    }
`;
